export const ConsumerNetIncomeErrorUat = {
  error: 'consumerNetIncome.generalError',
}
